// extracted by mini-css-extract-plugin
export default {"Information":"Information_Information__KMjnj"};